import React from "react";
import { PartnerFooter } from "./marketingAgency/shared";
import { PartnerLiveDeploymentSection } from "./marketingAgency/liveDeployment";
import { PartnerFormSection } from "./marketingAgency/partnerForm";
import InterceptProtocolNavbar from "./interceptProtocol/InterceptProtocolNavbar";
import InterceptHeroSection from "./interceptProtocol/hero/InterceptHeroSection";
import LeakedLeadTimelineSection from "./interceptProtocol/leakedLead/LeakedLeadTimelineSection";
import { RoiCalculatorSection } from "./marketingAgency/roiCalculator";
import { ComparisonTableSection } from "./marketingAgency/comparisonTable";
import TerritoryLockSection from "./interceptProtocol/territoryLock/TerritoryLockSection";
import SpeedGapSection from "./interceptProtocol/speedGap/SpeedGapSection";
import ProblemProofBridgeSection from "./interceptProtocol/problemProofBridge/ProblemProofBridgeSection";
import WhiteLabelWeaponSection from "./interceptProtocol/whiteLabelWeapon/WhiteLabelWeaponSection";
import WeaponHookBanner from "./interceptProtocol/weaponHook/WeaponHookBanner";

const INTERCEPT_ROI_INTRO =
  "Lock your niche, protect your ad campaigns, and activate $4.5k+ in pure monthly MRR from your existing client book.";

const InterceptProtocol = () => (
  <div className="partner-landing min-h-screen" data-testid="intercept-protocol-page">
    <InterceptProtocolNavbar />
    <InterceptHeroSection />
    <LeakedLeadTimelineSection />
    <SpeedGapSection />
    <ProblemProofBridgeSection />
    <PartnerLiveDeploymentSection id="live-deployment" />
    <WeaponHookBanner />
    <ComparisonTableSection id="infrastructure" compact />
    <TerritoryLockSection />
    <WhiteLabelWeaponSection />
    <RoiCalculatorSection introLine={INTERCEPT_ROI_INTRO} />
    <PartnerFormSection />
    <PartnerFooter />
  </div>
);

export default InterceptProtocol;
